// // VulnerableSoftwareList.jsx
// import CveSoftwareList from "app/patch/components/CVEList/CveSoftwareList";
// import ListDetailPane from "common-ui-components/components/list-detail-pane/ListDetailPane";
// import responseHandler from "app/manage/software-repository/utils/responseHandler";
// import React, { useEffect, useState } from "react";
// import API from "common-ui-components/components/utils/API";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useRouteMatch } from "utils/useRouteMatchCompat";
// import { navigateToManualDeployment } from "../utils/vulnerabilityUtils";
// import { unstable_batchedUpdates } from "react-dom";

// // Fetches CVEs for a version and renders CveSoftwareList
// const VersionDetail = ({ item }) => {
//   const [cves, setCves] = useState([]);
//   const [isLoading, setIsLoading] = useState(true); // --- Pagination States ---

//   const [page, setPage] = useState(0);
//   const [isFetchingMore, setIsFetchingMore] = useState(false);
//   const [hasMore, setHasMore] = useState(true);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { path } = useRouteMatch();

//   const fetchCves = async (pageNum) => {
//     try {
//       if (pageNum === 0) setIsLoading(true);
//       else setIsFetchingMore(true);

//       const response = await API.post(
//         `/vulnerabilities/cve-details?softwareVersionId=${item.id}&page=${pageNum}&size=30`,
//         {
//           search: [],
//           sort: {},
//           filter: [],
//         },
//       );
//       const formatted = responseHandler(response);
//       if (!formatted.ok) throw formatted;

//       const newCves = formatted.body?.result || []; // If we get fewer than 30 results, we've reached the end of the list

//       if (newCves.length < 30) {
//         setHasMore(false);
//       }

//       if (pageNum === 0) {
//         setCves(newCves);
//       } else {
//         // Append new results to the existing list
//         setCves((prev) => [...prev, ...newCves]);
//       }
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setIsLoading(false);
//       setIsFetchingMore(false);
//     }
//   };

//   useEffect(() => {
//     setPage(0);
//     setHasMore(true);
//     setCves([]);
//     fetchCves(0);
//   }, [item.id]);

//   const handleScrollBottom = () => {
//     // Lock to prevent duplicate API calls and stop fetching if no more data exists
//     if (isLoading || isFetchingMore || !hasMore) return;

//     const nextPage = page + 1;
//     setPage(nextPage);
//     fetchCves(nextPage);
//   };

//   if (isLoading && cves.length === 0)
//     return (
//       <div
//         className="shimmer"
//         style={{ margin: "1rem", height: "200px", borderRadius: "6px" }}
//       />
//     );

//   return (
//     <CveSoftwareList
//       items={cves}
//       isLoading={isLoading || isFetchingMore}
//       onCveClick={(cve) => {
//         navigate(
//           {
//             pathname: `cve-details`, // relative, not `${location.pathname}/cve-details`
//             search: `?cveId=${cve.cveId}`,
//           },
//           {
//             state: {
//               orgVulnerabilityId: cve.orgVulnerabilityId,
//             },
//           },
//         );
//       }}
//       onPatchNow={(cve) =>
//         navigateToManualDeployment(navigate, [
//           {
//             orgPatchId: cve?.orgPatchId,
//           },
//         ])
//       }
//       onScrollBottom={handleScrollBottom}
//     />
//   );
// };

// const buildVersionItems = (versions) =>
//   versions.map((v) => ({
//     id: v.softwareVersionId,
//     label: v.versionName,
//     otherMetaData: { count: v.cveCount },
//     detailComponent: VersionDetail,
//   }));

// const VulnerableSoftwareList = () => {
//   const [items, setItems] = useState([]);
//   const [isLoadingList, setIsLoadingList] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isSearching, setIsSearching] = useState(false);

//   useEffect(() => {
//     const fetch = async () => {
//       try {
//         unstable_batchedUpdates(() => {
//           setIsLoadingList(true);
//           if (searchQuery) setIsSearching(true);
//         });

//         const response = await API.post(
//           "/vulnerabilities/software-cve-summary",
//           {
//             search: searchQuery
//               ? [
//                   {
//                     column: "softwareName",
//                     searchKey: searchQuery,
//                   },
//                 ]
//               : [],
//             sort: {},
//             filter: [],
//           },
//         );

//         const formatted = responseHandler(response);
//         if (!formatted.ok) throw formatted;

//         // 1. Map the incoming API data to the UI format FIRST
//         const newSoftwaresMapped = (formatted.body?.result || []).map((s) => ({
//           id: s.softwareId,
//           label: s.softwareName,
//           otherMetaData: { count: s.cveCount },
//           items: [],
//           isLoading: false,
//         }));

//         setItems((prev) => {
//           const prevMap = new Map(prev.map((item) => [item.id, item]));

//           if (searchQuery) {
//             return newSoftwaresMapped.map((item) => {
//               const existing = prevMap.get(item.id);
//               return existing
//                 ? {
//                     ...item,
//                     items: existing.items,
//                     isLoading: existing.isLoading,
//                   }
//                 : item;
//             });
//           }

//           const prevIds = new Set(prev.map((item) => item.id));
//           const newlyAdded = newSoftwaresMapped.filter(
//             (item) => !prevIds.has(item.id),
//           );
//           return [...prev, ...newlyAdded];
//         });
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setIsLoadingList(false);
//         setIsSearching(false);
//       }
//     };
//     fetch();
//   }, [searchQuery]);

//   const handleSelect = async (id) => {
//     const item = items.find((i) => i.id === id);
//     if (!item) return; // Already loaded or currently loading — skip

//     if (item.items.length > 0 || item.isLoading) return; // Mark as loading

//     setItems((prev) =>
//       prev.map((i) => (i.id === id ? { ...i, isLoading: true } : i)),
//     );

//     try {
//       const response = await API.post(
//         `/vulnerabilities/software/${id}/versions-cve-summary`,
//         {
//           search: [],
//           sort: {},
//           filter: [],
//         },
//       );
//       const formatted = responseHandler(response);
//       if (!formatted.ok) throw formatted;

//       const versions = formatted.body?.result || [];

//       setItems((prev) =>
//         prev.map((i) =>
//           i.id === id
//             ? {
//                 ...i,
//                 isLoading: false,
//                 items: buildVersionItems(versions),
//               }
//             : i,
//         ),
//       );
//     } catch (e) {
//       console.error(e);
//       setItems((prev) =>
//         prev.map((i) => (i.id === id ? { ...i, isLoading: false } : i)),
//       );
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "35rem",
//       }}
//     >
//       {" "}
//       <ListDetailPane
//         data={{
//           listWidth: 20,
//           isLoading: isLoadingList,
//           items,
//         }}
//         onSelect={handleSelect}
//         searchNeeded={true}
//         containerProps={{ style: { height: "600px" } }}
//         isSearching={isSearching}
//         onSearch={(val) => setSearchQuery(val)}
//       />{" "}
//     </div>
//   );
// };

// export default VulnerableSoftwareList;
// VulnerableSoftwareList.jsx
import React from "react";
import VulnerabilityExplorer from "./file-explorer/VulnerabilityExplorer";
const VulnerableSoftwareList = () => (
  <VulnerabilityExplorer
    softwareSummaryUrl="/vulnerabilities/software-cve-summary"
    versionSummaryUrl={(softwareId) =>
      `/vulnerabilities/software/${softwareId}/versions-cve-summary`
    }
    cveDetailsUrl={(versionId) =>
      `/vulnerabilities/cve-details?softwareVersionId=${versionId}`
    }
    height="35rem"
  />
);

export default VulnerableSoftwareList;
